import BigNumber from "bignumber.js";
import sleep from "../../factories/Sleep";
import ExponentialBackoff from "../../factories/ExponentialBackoff";
import AtomicSwapOracle from "../../factories/AtomicSwapOracle";
import ERC20 from "../../factories/web3/ERC20";
import OKLGAtomicSwapInstance from "../../factories/web3/OKLGAtomicSwapInstance";
import OKLGAtomicSwap from "../../factories/web3/OKLGAtomicSwap";
import Web3Modal from "../../factories/web3/Web3Modal";
import OKLGSpend from "../../factories/web3/OKLGSpend";

export default {
  state: () => ({
    initLoading: false,
    activeNetwork: '',
    web3: {
      instance: null,
      isConnected: false,
      chainId: null,
      address: "",
      userMtgyBalance: "",
      mainCurrencyBalance: "",
    },
    selectedAddressInfo: {
      address: "",
      name: "",
      symbol: "",
      decimals: "",
      userBalance: "",
    },
    asaas: {
      createSwapCost: null,
      swapCost: null,
      instanceGasCost: {},
      instanceServiceCost: {},
      gas: null,
      swaps: [],
    },
    eth: {
      networks: [
        {
          name: "Binance Smart Chain",
          short_name: "bsc",
          chain: "smartchain",
          network: "mainnet",
          chain_id: 56,
          network_id: 56,
          explorer_url: "https://bscscan.com",
          rpc_url: "https://bsc-dataseed.binance.org/",
          blocks_per_day: 28800,
          native_currency: {
            symbol: "BNB",
            name: "BNB",
            decimals: 18,
            contractAddress: "",
            balance: "",
          },
          logo: `img/bsc.png`,
          contracts: {
            oklg: "0x55e8b37a3c43b049dedf56c77f462db095108651",
            spend: "0x3B971D415671D9e909562aA02b02f0BfbD572c07",
            buybackAndBurn: "0x2796844A84D8eef9aE02e60C18Cd713Dd29659B7",
            airdropper: "0xFEA788C8e1C60b9C911265cAc63f4067AC1Ce42F",
            atomicSwap: "0x12B2B415cc5555e955B83a779644DF9eeFAF5140",
            passwordManager: "0x31FE24955A0de9c5a9818DAA8d7A614eFEdb5F34",
            raffler: "0x0525a5A67820af53066713BfC5c368BD2C8A570e",
            trustedTimestamping: "0xBa63F51f7Be4022dd7BfF997BC3245c5F651B381",
            faas: "0x717EDe6051acf094Ff043E2B3BcC4F86262742DD",
            faas_V1: "0x701666359E71b38d61C7faD2A121D7e6A6F1fFff",
          },
          buy: {
            link:
              "https://exchange.pancakeswap.finance/#/swap?inputCurrency=0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c&outputCurrency=0x55e8b37a3c43b049dedf56c77f462db095108651",
            img: "img/pancakeswap.png",
            text: "PancakeSwap",
          },
        },
        {
          name: "Ethereum Mainnet",
          short_name: "eth",
          chain: "ETH",
          network: "mainnet",
          chain_id: 1,
          network_id: 1,
          explorer_url: "https://etherscan.io",
          rpc_url: "https://mainnet.infura.io/v3/%API_KEY%",
          blocks_per_day: 6450,
          native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: 18,
            contractAddress: "",
            balance: "",
          },
          contracts: {
            oklg: "0x5dbb9f64cd96e2dbbca58d14863d615b67b42f2e",
            spend: "0x5bDE378E0a0ceBc941B03a579DA0088DC1616FAF",
            buybackAndBurn: "0xd501812C4FF29B0B95566a146078A218B1f7B78F",
            airdropper: "0x46510e381823Fe82d77d8F25ba78b0abD50eD444",
            atomicSwap: "0x967958DB20F9466d2fB3F1deE866671155Fb308f",
            passwordManager: "0x026132e2104ED39d9767334648052A731D0d483E",
            raffler: "0xBcA35f4b6343194c03C04c9340bAFD3de3E0284c",
            trustedTimestamping: "0xf02bc60b34A0656D35d7D57Bf9B535E945c4F1a9",
            faas: "0x7c2de66461Ba16839A5FeB5acC22a995036c3971",
            faas_V1: "0x521C1A07dB23cEEF2126EBf1924E31D55284918D",
            kether: "0xb5fe93ccfec708145d6278b0c71ce60aa75ef925",
            ketherNFT: "0x7bb952AB78b28a62b1525acA54A71E7Aa6177645",
            ketherNFTLoaner: "0x6d02744ef4418CB0D72f54c1eE53140430b9dBEd",
          },
          buy: {
            link:
              "https://app.uniswap.org/#/swap?outputCurrency=0x5dbb9f64cd96e2dbbca58d14863d615b67b42f2e",
            img: "img/uniswap.png",
            text: "Uniswap",
          },
        },
      ]
    },
    productIds: {
      airdropper: 1,
      passwordManager: 2,
      trustedTimestamping: 3,
      raffler: 4,
      tokenLocker: 5,
      atomicSwap: 6,
      atomicSwapInstance: 7,
      faas: 8,
    },
  }),
  getters: {
    isConnected(state) {
      return state.web3.isConnected;
    },

    initLoading(state) {
      return state.initLoading
    },

    activeNetwork(state) {
      return state.eth.networks.find((n) => n.chain_id === state.web3.chainId);
    },

    swap(state, getters) {
      if (state.web3.isConnected && !state.initLoading && state.asaas.swaps.length > 0) {
        return state.asaas.swaps.filter(fs => {
          if (getters.activeNetwork.short_name == 'eth' && fs.targetToken != null) {
            return fs.targetNetwork == 'bsc' && fs.sourceContract  == "0xFF9B8058035a60967fAA7be23259E875E8684D6F"
          } else if (getters.activeNetwork.short_name == 'bsc' && fs.targetToken != null) {
            return fs.targetNetwork == 'eth' && fs.sourceContract  == "0xd9f88864084df791BE54DEa9BE1C6788837e87d4"
          }
        })[0]
      } else {
        return null
      }
    },

    web3(state) {
      return state.web3
    }
  },
  mutations: {
    SET_INIT_LOADING(state, isLoading) {
      state.initLoading = isLoading;
    },

    SET_SELECTED_ADDRESS(state, address) {
      state.selectedAddressInfo.address = address;
    },

    SET_SELECTED_ADDRESS_INFO(state, info) {
      const keys = Object.keys(info);
      state.selectedAddressInfo = {
        ...state.selectedAddressInfo,
        ...keys.reduce((o, key) => ({ ...o, [key]: info[key] }), {}),
      };
    },

    SET_WEB3_IS_CONNECTED(state, isConnected) {
      state.web3.isConnected = isConnected;
    },

    SET_WEB3_CHAIN_ID(state, chainId) {
      state.web3.chainId = chainId;
    },

    SET_WEB3_INSTANCE(state, web3) {
      state.web3.instance = web3;
    },

    SET_WEB3_PROVIDER(state, provider) {
      state.web3.provider = provider;
    },

    SET_WEB3_USER_ADDRESS(state, addy) {
      state.web3.address = addy;
    },

    SET_WEB3_USER_MTGY_BALANCE(state, balance) {
      state.web3.userMtgyBalance = balance;
    },

    SET_WEB3_MAIN_BALANCE(state, balance) {
      state.web3.mainCurrencyBalance = balance;
    },

    SET_ASAAS_INSTANCE_GAS_COST(state, { contractAddress, instanceGasCost }) {
      state.asaas.instanceGasCost = {
        ...state.asaas.instanceGasCost,
        [contractAddress]: instanceGasCost,
      };
    },

    SET_ASAAS_INSTANCE_SERVICE_COST(state, { contractAddress, serviceCost }) {
      state.asaas.instanceServiceCost = {
        ...state.asaas.instanceServiceCost,
        [contractAddress]: serviceCost,
      };
    },

    SET_ASAAS_SWAPS(state, contracts) {
      state.asaas.swaps = contracts;
    },
  },
  actions: {
    async init({ commit, dispatch, getters, state }, reset = false) {
      try {
        if (state.web3 && state.web3.isConnected && !reset) return;
        commit("SET_INIT_LOADING", true)
        const { provider, web3 } = await Web3Modal.connect();
        commit("SET_WEB3_PROVIDER", provider);
        commit("SET_WEB3_INSTANCE", web3);
        commit("SET_WEB3_IS_CONNECTED", true);
        const resetConnection = async () => {
          dispatch("disconnect");
          await dispatch("init", true);
          localStorage.mccLoggedIn = true
          localStorage.WEB3_CONNECT_CACHED_PROVIDER = '"injected"'
        };
        Web3Modal.bindProviderEvents({
          accountsChanged: resetConnection,
          chainChanged: resetConnection,
          disconnect: () => dispatch("disconnect"),
        });

        commit("SET_WEB3_CHAIN_ID", await web3.eth.getChainId());
        const [accountAddy] = await web3.eth.getAccounts();
        commit("SET_WEB3_USER_ADDRESS", accountAddy);
        await dispatch('getAllSwapContracts');
      } catch (err) {
        console.log(err)
      } finally {
        commit("SET_INIT_LOADING", false)
        localStorage.mccLoggedIn = true
      }
    },
    disconnect({ commit }) {
      commit("SET_WEB3_PROVIDER", null);
      commit("SET_WEB3_INSTANCE", null);
      commit("SET_WEB3_IS_CONNECTED", false);
      commit("SET_WEB3_CHAIN_ID", null);
      commit("SET_WEB3_USER_ADDRESS", "");

      // Clear cached provider to be able to switch between providers when disconnecting wallet
      Web3Modal.clearCachedProvider();
      localStorage.removeItem("mccLoggedIn")
    },

    async asaasInstanceGasCost({ commit, dispatch, state }, contractAddress) {
      const web3 = state.web3.instance;
      const productID = state.productIds.atomicSwapInstance;
      const contract = OKLGAtomicSwapInstance(web3, contractAddress);
      const [serviceCost, instanceGasCost] = await Promise.all([
        dispatch("getProductCostWei", {
          productID,
          productContract: contractAddress,
        }),
        contract.methods.minimumGasForOperation().call(),
      ]);
      commit("SET_ASAAS_INSTANCE_GAS_COST", {
        contractAddress,
        instanceGasCost,
      });
      commit("SET_ASAAS_INSTANCE_SERVICE_COST", {
        contractAddress,
        serviceCost,
      });
    },

    async getAllSwapContracts({ commit, dispatch, getters, state }) {
      const web3 = state.web3.instance;
      const userAddy = state.web3.address;
      const activeNetwork = getters.activeNetwork;
      if (!activeNetwork) {
        await sleep(500);
        return await dispatch("getAllSwapContracts");
      }
      const asaasAddy = activeNetwork.contracts.atomicSwap;
      const asaasAddy_V1 = activeNetwork.contracts.atomicSwap_V1;
      const contract = OKLGAtomicSwap(web3, asaasAddy);
      const contract_V1 = asaasAddy_V1 && OKLGAtomicSwap(web3, asaasAddy_V1);
      const [allSwaps, allSwaps_V1] = await Promise.all([
        contract.methods.getAllSwapContracts().call(),
        (async () => {
          if (contract_V1) {
            return await contract_V1.methods.getAllSwapContracts().call();
          }
          return [];
        })(),
      ]);
      const mappedSwaps = await Promise.all(
        allSwaps.concat(allSwaps_V1).map(async (swap) => {
          try {
            const sourceSwapInst = OKLGAtomicSwapInstance(
              web3,
              swap.sourceContract
            );

            const isSwapActive = await sourceSwapInst.methods.isActive().call();
            if (!(isSwapActive && swap.isActive))
              throw new Error(
                `Swap doesn't appear to be active: source - ${swap.sourceContract}; target - ${swap.targetContract}`
              );

            const [
              swapTokenAddy,
              targetToken,
              unclaimedSentFromSource,
              { swap: unclaimedSentFromTarget },
            ] = await Promise.all([
              sourceSwapInst.methods.getSwapTokenAddress().call(),
              (async () => {
                try {
                  return await AtomicSwapOracle.getSwap({
                    userAddress: userAddy,
                    sourceNetwork: activeNetwork.short_name,
                    sourceContract: swap.sourceContract,
                  });
                } catch (err) {
                  console.error(`Error getting swap info`, err);
                  return null;
                }
              })(),
              (async () => {
                const lastUserSwap = await sourceSwapInst.methods
                  .lastUserSwap(userAddy)
                  .call();
                if (lastUserSwap) {
                  return await sourceSwapInst.methods
                    .swaps(lastUserSwap.id)
                    .call();
                }
              })(),
              (async () => {
                try {
                  return await AtomicSwapOracle.getLastUserSwap(
                    swap.targetNetwork,
                    userAddy,
                    swap.targetContract
                  );
                } catch (err) {
                  console.error(`Error getting target unclaimed info`, err);
                  return null;
                }
              })(),
            ]);
            const token = await dispatch("getErc20TokenInfo", swapTokenAddy);
            const tokenCont = ERC20(web3, token.address);
            return {
              unclaimedSentFromSource,
              unclaimedSentFromTarget,
              targetToken,
              token: {
                ...token,
                contractBalance: await tokenCont.methods
                  .balanceOf(swap.sourceContract)
                  .call(),
              },
              ...swap,
            };
          } catch (err) {
            console.error(`Error get swap`, err);
            return null;
          }
        })
      );
      commit(
        "SET_ASAAS_SWAPS",
        mappedSwaps.filter((s) => !!s)
      );
    },

    async asaasGetLatestUserSwap({ state }, sourceContract) {
      const web3 = state.web3.instance;
      const userAddy = state.web3.address;
      const contract = OKLGAtomicSwapInstance(web3, sourceContract);
      return await contract.methods.lastUserSwap(userAddy).call();
    },

    async getErc20TokenInfo({ state }, tokenAddy) {
      const userAddy = state.web3.address;
      const contract = ERC20(state.web3.instance, tokenAddy);
      const [name, symbol, decimals, userBalance] = await Promise.all([
        contract.methods.name().call(),
        contract.methods.symbol().call(),
        contract.methods.decimals().call(),
        contract.methods.balanceOf(userAddy).call(),
      ]);
      return {
        address: tokenAddy,
        name,
        symbol,
        decimals,
        userBalance,
      };
    },
    async sendTokensToSwap(
      { dispatch, getters, state },
      { amount, sourceContract, tokenContract }
    ) {
      const web3 = state.web3.instance;
      const userAddy = state.web3.address;
      const productID = state.productIds.atomicSwapInstance;
      const nativeCurrencySymbol = getters.nativeCurrencySymbol;
      const contract = OKLGAtomicSwapInstance(web3, sourceContract);
      const [nativeBalance, serviceCost] = await Promise.all([
        state.web3.instance.eth.getBalance(userAddy),
        dispatch("getProductCostWei", {
          productID,
          productContract: sourceContract,
        }),
      ]);
      const totalNativeNeeded = new BigNumber(
        state.asaas.instanceGasCost[sourceContract] || 0
      ).plus(serviceCost || 0);
      if (new BigNumber(nativeBalance).lt(totalNativeNeeded)) {
        throw new Error(
          `You do not have enough ${nativeCurrencySymbol} to cover the service cost. Please ensure you have enough ${nativeCurrencySymbol} in your wallet to cover the service fee and try again.`
        );
      }

      await dispatch("genericErc20Approval", {
        spendAmount: amount,
        tokenAddress: tokenContract,
        delegateAddress: sourceContract,
      });
      return await contract.methods.receiveTokensFromSource(amount).send({
        from: userAddy,
        value: totalNativeNeeded.toFixed(),
      });
    },
    async genericErc20Approval(
      { state },
      { spendAmount, tokenAddress, delegateAddress, unlimited }
    ) {
      if (new BigNumber(spendAmount || 0).lte(0)) return;

      unlimited = unlimited === false ? false : true;
      const userAddy = state.web3.address;
      const contract = ERC20(state.web3.instance, tokenAddress);
      const [userBalance, currentAllowance] = await ExponentialBackoff(
        async () => {
          return await Promise.all([
            contract.methods.balanceOf(userAddy).call(),
            contract.methods.allowance(userAddy, delegateAddress).call(),
          ]);
        }
      );
      if (new BigNumber(currentAllowance).lte(spendAmount || 0)) {
        await contract.methods
          .approve(
            delegateAddress,
            unlimited
              ? new BigNumber(2).pow(256).minus(1).toFixed()
              : userBalance
          )
          .send({ from: userAddy });
      }
    },

    async asaasFundAndClaimTokens(
      { getters, state },
      { instContract, id, timestamp, amount }
    ) {
      const web3 = state.web3.instance;
      const activeNetwork = getters.activeNetwork;
      const userAddy = state.web3.address;
      const contract = OKLGAtomicSwapInstance(web3, instContract);
      const [valueToSend, currentSwap] = await Promise.all([
        contract.methods.minimumGasForOperation().call(),
        contract.methods.swaps(id).call(),
      ]);
      if (!currentSwap.isSendGasFunded) {
        await contract.methods
          .fundSendToDestinationGas(id, timestamp, amount)
          .send({ from: userAddy, value: valueToSend });
      }
      await AtomicSwapOracle.sendTokens({
        targetNetwork: activeNetwork.short_name,
        targetContract: instContract,
        targetSwapId: id,
      });

      // poll for completion status to handle txns taking longer than
      // the 30 second HTTP limit (some chains can be deathly slow/congested)
      let isComplete = false;
      let tries = 0;
      let waitIntervalSec = 5;
      let numTotalTries = (2 * 60) / 5; // 2 min of tries
      while (!isComplete && tries < numTotalTries) {
        const { source, target } = await AtomicSwapOracle.sendTokens({
          checkOnly: true,
          targetNetwork: activeNetwork.short_name,
          targetContract: instContract,
          targetSwapId: id,
        });
        // If 'source' is complete it means the user received their tokens
        // which is all they care about anyway, so only check source for now
        // isComplete = source && target;
        isComplete = source;
        if (!isComplete) {
          await sleep(waitIntervalSec * 1e3);
        }
        tries++;
      }
      if (tries >= numTotalTries) {
        throw new Error(
          `Please check and confirm your tokens have landed in your wallet. If not please try clicking the claim button one more time. If you see this message again, please contract support to claim your tokens.`
        );
      }
    },
    async refundTokens(
      { getters, state },
      { instContract, id, timestamp, amount }
    ) {
      const web3 = state.web3.instance;
      const activeNetwork = getters.activeNetwork;
      const userAddy = state.web3.address;
      const contract = OKLGAtomicSwapInstance(web3, instContract);
      const [valueToSend, currentSwap] = await Promise.all([
        contract.methods.minimumGasForOperation().call(),
        contract.methods.swaps(id).call(),
      ]);
      if (!currentSwap.isSendGasFunded) {
        await contract.methods
          .fundSendToDestinationGas(id, timestamp, amount)
          .send({ from: userAddy, value: valueToSend });
      }
      await AtomicSwapOracle.refundTokens({
        targetNetwork: activeNetwork.short_name,
        targetContract: instContract,
        targetSwapId: id,
      });

      // poll for completion status to handle txns taking longer than
      // the 30 second HTTP limit (some chains can be deathly slow/congested)
      let isComplete = false;
      let tries = 0;
      let waitIntervalSec = 5;
      let numTotalTries = (2 * 60) / 5; // 2 min of tries
      while (!isComplete && tries < numTotalTries) {
        const { source: isRefundedYet } = await AtomicSwapOracle.refundTokens({
          checkOnly: true,
          targetNetwork: activeNetwork.short_name,
          targetContract: instContract,
          targetSwapId: id,
        });
        // If 'source' is complete it means the user received got refunded
        isComplete = isRefundedYet;
        if (!isComplete) {
          await sleep(waitIntervalSec * 1e3);
        }
        tries++;
      }
      if (tries >= numTotalTries) {
        throw new Error(
          `Please check and confirm your tokens have landed in your wallet. If not please try clicking the refund button one more time. If you see this message again, please contract support to refund your tokens.`
        );
      }
    },
    async getProductCostWei(
      { getters, state },
      { productID, productContract }
    ) {
      const web3 = state.web3.instance;
      const spendCont = getters.activeNetwork.contracts.spend;
      const spend = OKLGSpend(web3, spendCont);
      const [defaultCostUSD, overrideCostUSD] = await Promise.all([
        spend.methods.defaultProductPriceUSD(productID).call(),
        spend.methods.overrideProductPriceUSD(productContract).call(),
      ]);
      const [defaultCostWei, overrideCostWei, isRemoved] = await Promise.all([
        spend.methods.getProductCostWei(defaultCostUSD).call(),
        spend.methods.getProductCostWei(overrideCostUSD).call(),
        spend.methods.removeCost(productContract).call(),
      ]);
      return isRemoved
        ? "0"
        : new BigNumber(overrideCostWei).gt(0)
          ? overrideCostWei
          : defaultCostWei;
    }
  }
}